export default [
  {
    name: "大林口俯瞰圖",
    //imgSrc: require("../assets/img/nav/view.png"),
    subTitle: "",
    section: "section2",
    svgSrc: "",
    offset: -70,
    mobileOffset: -60
  },
  {
    name: "全時交通",
    imgSrc: "",
    subTitle: "",
    section: "section3",
    svgSrc: "",
    offset: 100,
    mobileOffset: -50
  },
  {
    name: "願景未來",
    imgSrc: "",
    subTitle: "",
    section: "section4",
    svgSrc: "",
    offset: 100,
    mobileOffset: -50
  },
  {
    name: "機能學區",
    imgSrc: "",
    subTitle: "",
    section: "section5",
    svgSrc: "",
    offset: -150,
    mobileOffset: 580
  },
  {
    name: "公園綠地",
    imgSrc: "",
    subTitle: "",
    section: "section6",
    svgSrc: "",
    offset: -80,
    mobileOffset: -50
  },
  {
    name: "極上公設",
    imgSrc: "",
    subTitle: "",
    section: "section6-scroll",
    svgSrc: "",
    offset: -80,
    mobileOffset: -50
  },
  {
    name: "閱讀人文",
    imgSrc: "",
    subTitle: "",
    section: "section7",
    svgSrc: "",
    offset: 100,
    mobileOffset: -50
  },
  {
    name: "預約賞屋",
    imgSrc: "",
    subTitle: "",
    section: "contact",
    svgSrc: "",
    offset: -200,
    mobileOffset: -50
  }
];
